import {Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {FormControl, Validators} from '@angular/forms';
import {Contract} from '../../model/Entities/Contract';
import {ContractItemTransfer} from '../../model/Entities/ContractItemTransfer';
import {ContractItemsTransferListComponent} from '../ContractItemsTransferListComponent/contract-items-transfer-list.component';
import {ContractItem} from '../../model/Entities/ContractItem';
import {ContractItemService} from '../../services/contract-item.service';

@Component({
    selector: 'contract-group-item-loss-dialog',
    templateUrl: './contract-group-item-loss.dialog.component.html',
    styleUrls: ['./contract-group-item-loss.dialog.component.scss']
})
export class ContractGroupItemLossDialogComponent {

    public contractItem: ContractItem;
    public groupItems: any[] = [];

    // @ViewChild('itemsTransferList') itemsTransferList: ContractItemsTransferListComponent;

    constructor(public dialog: MatDialogRef<ContractGroupItemLossDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private contractItemService: ContractItemService) {
        this.contractItem = data.contractItem;
    }

    public save(): void {
        this.groupItems.forEach((i) => {
            if (i.lostCount <= 0) {
                return;
            }

            // console.log('LOST ' + i.lostCount + ' pcs of ' + i.content.name);
            this.contractItemService.addLostItem(i, this.contractItem.contractId);
        });

        setTimeout(() => {
            this.contractItemService.notifyChanges();
        }, 1000);

    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractGroupItemLossDialogComponent/contract-group-item-loss.dialog.component.ts